import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import RecipientInformationsStep from './steps/RecipientInformationsStep';
import ItemsInformationsStep from './steps/ItemsInformationsStep';
import SelectPickupPointStep from './steps/SelectPickupPointStep';
import PricesStep from './steps/PricesStep';
import { getPrices, addCommand } from './addCommandActions';
import { Title } from '../style';

const AddCommand = ({
  dispatchGetPrices,
  getPricesParams,
  deliveryType,
  addCommandParams,
  dispatchAddCommand
}) => {
  const [currentStep, setCurrentStep] = useState(0);

  const nextPage = () => {
    if (currentStep === 1 && deliveryType !== 'pickupPoint') {
      setCurrentStep(3);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  const previousPage = () => {
    if (currentStep === 3 && deliveryType !== 'pickupPoint') {
      setCurrentStep(1);
    } else {
      setCurrentStep(currentStep - 1);
    }
  };

  const price = () => {
    dispatchGetPrices(getPricesParams);
  };

  const onSubmit = () => {
    dispatchAddCommand(addCommandParams);
  };

  return (
    <>
      <Grid container spacing={10}>
        <Grid item md={6}>
          <Title>Créer une commande</Title>
        </Grid>
      </Grid>
      <Grid
        container
        alignContent="center"
        alignItems="center"
        justify="center"
      >
        <Grid item md={6}>
          {currentStep === 0 && (
            <RecipientInformationsStep onSubmit={nextPage} />
          )}
          {currentStep === 1 && (
            <ItemsInformationsStep
              previousPage={previousPage}
              onSubmit={nextPage}
            />
          )}
          {currentStep === 2 && (
            <SelectPickupPointStep
              previousPage={previousPage}
              nextPage={nextPage}
            />
          )}
          {currentStep === 3 && (
            <PricesStep
              previousPage={previousPage}
              onSubmit={onSubmit}
              getPrices={price}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = state => {
  const selector = formValueSelector('addCommandForm');
  const {
    productIsInStock,
    deliveryType,
    recipientAddress,
    type,
    recipient,
    items,
    externalReference,
    insuranceAmount
  } = selector(
    state,
    'productIsInStock',
    'deliveryType',
    'recipientAddress',
    'externalReference',
    'recipient',
    'insuranceAmount',
    'type',
    'items'
  );
  return {
    deliveryType,
    getPricesParams: {
      ...recipientAddress,
      ...type,
      deliveryType,
      commandType: 'small_object'
    },
    addCommandParams: {
      readyToBePickedUp: productIsInStock === 'inStock',
      recipientAddress,
      recipient,
      ...type,
      items,
      customsDeclarations: items
        ? items.map(item => ({
            ...item.customsDeclaration,
            quantity: item.quantity
          }))
        : null,
      deliveryType,
      externalReference,
      commandType: 'small_object',
      isHidden: true,
      isFragile: true,
      isPrecious: true,
      insuranceAmount: +insuranceAmount,
      offerCode: state.addCommand.selectedOffer
        ? state.addCommand.selectedOffer.offer.code
        : null,
      pickupPoint: {
        id: state.addCommand.selectedPickupPoint.id
      }
    }
  };
};
const mapDipatchToProps = dispatch => ({
  dispatchGetPrices: params => dispatch(getPrices(params)),
  dispatchAddCommand: data => dispatch(addCommand(data))
});

AddCommand.propTypes = {
  dispatchGetPrices: PropTypes.func.isRequired,
  dispatchAddCommand: PropTypes.func.isRequired,
  getPricesParams: PropTypes.object.isRequired,
  deliveryType: PropTypes.string,
  addCommandParams: PropTypes.object
};

export default connect(mapStateToProps, mapDipatchToProps)(AddCommand);
